var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2756 28.2084V18.2665C10.2756 17.1067 10.9041 15.2477 13.892 12.9672C15.668 11.6147 17.5149 10.6868 18.021 10.445C18.527 10.6868 20.3771 11.6147 22.1499 12.9672C25.141 15.2477 25.7695 17.1067 25.7695 18.2665V28.2084H10.2756ZM27.0105 4.03164C22.5979 1.21864 18.1209 0.0326713 18.079 0.0196028L18.0016 0L17.9243 0.0196028C17.8791 0.0326713 13.4472 1.21864 9.05399 4.03164C4.97019 6.64208 0.0838034 11.2324 0 18.2502V38H36V18.2502C36 11.2324 31.1104 6.64534 27.0105 4.03164Z",
    fill: "#F37A17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent1);
export default __webpack_public_path__ + "static/media/event-1.3d1d31991183feeddcf762e00ab7157c.svg";
export { ForwardRef as ReactComponent };